import { render } from "./TvmFeatureTiles.vue?vue&type=template&id=6d18831c&scoped=true"
import script from "./TvmFeatureTiles.vue?vue&type=script&lang=js"
export * from "./TvmFeatureTiles.vue?vue&type=script&lang=js"

import "./TvmFeatureTiles.vue?vue&type=style&index=0&id=6d18831c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d18831c"]])

export default __exports__